import logo_negro from "./general/Inmersys_Logo_Negro.png";
import logo_blanco from "./general/Inmersys_Logo_Blanco.png";
import logo from "./general/Logo.png";
import loginBg from "./general/login-bg.png";
import manitence from "./manitence.jpg";
import usaFlag from "./icons/icon_usa.png";
import mexicoFlag from "./icons/icon_mexico.png";

export const imagesgeneral = {
	logo_negro,
	logo_blanco,
	manitence,
	logo,
	loginBg,
	usaFlag,
	mexicoFlag,
};
